<template>
  <FormKit
    id="dest-address-form"
    v-model="values"
    #="{ state: { valid } }"
    type="form"
    form-class="grid devis-form"
    :actions="false"
    :incomplete-message="false"
  >
    <FormKit
      id="destPostalAddress"
      type="text"
      name="destPostalAddress"
      outer-class="g-col-12 g-col-lg-6"
      :label="__('Postal address:', 'smdt')"
      :placeholder="__('Postal address:', 'smdt')"
      :value="values.destPostalAddress"
    />
    <FormKit
      id="destPostalCode"
      type="text"
      name="destPostalCode"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required"
      :label="__('Postal code:', 'smdt')"
      :placeholder="__('Postal code:', 'smdt')"
      :value="values.destPostalCode"
    />
    <FormKit
      id="destCity"
      type="text"
      name="destCity"
      outer-class="g-col-12 g-col-lg-6 required"
      validation="required"
      :label="__('City:', 'smdt')"
      :placeholder="__('City:', 'smdt')"
      :value="values.destCity"
    />
    <FormKit
      id="destCountry"
      type="text"
      name="destCountry"
      outer-class="g-col-12 g-col-lg-6"
      :label="__('Country:', 'smdt')"
      :placeholder="__('Country:', 'smdt')"
      :value="values.destCountry"
    />
    <FormKit
      id="destFloor"
      type="number"
      name="destFloor"
      outer-class="g-col-12 g-col-lg-6"
      :label="__('Floor:', 'smdt')"
      :placeholder="__('Floor:', 'smdt')"
      :value="values.destFloor"
      :min="0"
    />
    <FormKit
      type="checkbox"
      outer-class="devis-toggle g-col-12 g-col-lg-6"
      name="destAddressFields"
      :options="[
        __('Stairs', 'smdt'),
        __('Elevator', 'smdt'),
        __('Parking', 'smdt'),
      ]"
    />
    <FormKit
      id="destInformation"
      type="textarea"
      name="destInformation"
      outer-class="g-col-12"
      :label="__('Further informations:', 'smdt')"
      :placeholder="__('Specify any access difficulties: narrow or sloping street, need for a furniture lift, transshipment, impossible parking nearby and other difficulties.', 'smdt')"
      :value="values.destInformation"
    />
    <div class="g-col-12">
      <div class="devis-btn-group">
        <button
          type="button"
          class="devis-btn devis-btn--white"
          @click="goStep(0)"
        >
          {{ __('Previous step', 'smdt') }}
        </button>
        <button
          type="button"
          class="devis-btn"
          :disabled="!valid"
          @click="goStep(2)"
        >
          {{ __('Next step', 'smdt') }}
        </button>
      </div>
    </div>
  </FormKit>
</template>

<script>
import { watch } from 'vue'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StageOne',
  props: {
    stage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapWritableState(useStagesStore, ['values']),
    ...mapState(useStagesStore, [
      'apiData',
      'currentStageData',
      'updateState',
      'updateValues',
      'goStep',
    ]),
    subtitle() {
      const { title, subtitle } = this.currentStageData
      return `${title} ${subtitle}`
    },
  },
  mounted() {
    const node = this.$formkit.get('dest-address-form')
    const isValid = node.context.state

    watch(isValid, (val) => {
      const { valid } = val
      this.setValid(valid)
    })
  },
  methods: {
    ...mapActions(useStagesStore, ['setValid']),
    __,
  },
}
</script>

<style scoped lang="scss"></style>
